import * as React from 'react';

type Props = React.HTMLAttributes<HTMLSpanElement>;

export const VisuallyHidden = React.forwardRef(function VisuallyHidden(props: Props, ref: React.Ref<HTMLSpanElement>) {
    return <span {...props} className="sr-only" ref={ref} />;
});
